import MojitoPresentation from 'mojito/presentation';
import { range } from 'mojito/utils';
import PrebuiltBetsSkeleton from 'modules/prebuilt-bets/skeleton/index.js';

const { SkeletonPart, FlexPane } = MojitoPresentation.Components;

export default function PrebuiltBetBuilderCouponSkeleton(props) {
    const {
        mojitoTools: { config },
    } = props;
    return (
        <FlexPane config={config.сontainer}>
            {range(config.numberOfPBBBEvents).map(key => (
                <FlexPane key={key} config={config.eventContainer}>
                    <FlexPane config={config.eventHeaderContainerSkeleton}>
                        <SkeletonPart config={config.eventNameLabelSkeleton} />
                        <SkeletonPart config={config.startTimeSkeleton} />
                    </FlexPane>
                    <PrebuiltBetsSkeleton config={config.prebuiltBetsSkeleton} />
                </FlexPane>
            ))}
        </FlexPane>
    );
}
